export const HIGHLIGHTS_REQUEST_SEND = 'HIGHLIGHTS_REQUEST_SEND';
export const HIGHLIGHTS_REQUEST_SUCCESS = 'HIGHLIGHTS_REQUEST_SUCCESS';
export const HIGHLIGHTS_REQUEST_FAILURE = 'HIGHLIGHTS_REQUEST_FAILURE';
